import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer-pastelaria">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Coluna 1 - Sobre */}
          <div className="footer-coluna">
            <h3 className="footer-titulo">Mordida de Sonho</h3>
            <p className="footer-texto">
              Pastelaria tradicional portuguesa com produtos artesanais feitos com amor e dedicação desde 2015.
            </p>
          </div>

          {/* Coluna 2 - Links Rápidos */}
          <div className="footer-coluna">
            <h3 className="footer-titulo">Links Rápidos</h3>
            <ul className="footer-links">
              <li><Link to="/">Início</Link></li>
              <li><Link to="/produtos">Produtos</Link></li>
              <li><Link to="/sobre">Sobre Nós</Link></li>
              <li><Link to="/contato">Contato</Link></li>
            </ul>
          </div>

          {/* Coluna 3 - Contato */}
          <div className="footer-coluna">
            <h3 className="footer-titulo">Contato</h3>
            <ul className="footer-contato">
              <li>
                <MapPin size={18} />
                <span>Rua das Flores, 123<br />Lisboa, Portugal</span>
              </li>
              <li>
                <Phone size={18} />
                <span>+351 21 123 4567</span>
              </li>
              <li>
                <Mail size={18} />
                <span>info@mordidadesonho.pt</span>
              </li>
            </ul>
          </div>

          {/* Coluna 4 - Redes Sociais */}
          <div className="footer-coluna">
            <h3 className="footer-titulo">Redes Sociais</h3>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={24} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={24} />
              </a>
            </div>
            <p className="footer-horario">
              <strong>Horário:</strong><br />
              Seg-Sex: 7h - 20h<br />
              Sábado: 8h - 19h<br />
              Domingo: 9h - 18h
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 Mordida de Sonho. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
